import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }

import Keys from '@/constant/key'
import SelectChannel from '../../components/SelectChannel.vue'
import { joinParams } from '@/utils/index'
import Pagination from '@/components/Pagination.vue'
import { useStore } from '@/store/index'
import { useRouter } from 'vue-router'
import { getCurrentInstance, reactive, onMounted, ref } from 'vue'
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProductLog',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
    const router = useRouter()
    const store = useStore()
    const filters = reactive({
            channel_name:'',
            channel_no:'',
            title:         '',     // 商品名称
            start_date:         '',     // 开始日期
            end_date:           '',     // 结束日期
            page:        1,      // 当前页码
            page_size:          10,     // 每页显示条数
    })
    const state =reactive({
        dialogVisible: false,   // 弹框
    })
    const tableData = ref([])
    const total = ref(0)
    // 获取列表数据
    const getList = () => {
        proxy.$http.get('/cake_api/productChannelLog', filters).then(res => {
            const { code, data, msg } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            tableData.value = data.data
            total.value = data.total
        })
    }
    // 渠道变化监听
    const onChannelChange = (val) => {
        filters.channel_no = val ? val.channel_no : ''
    }
    const out = (type) => {
        window.open(`${Keys.baseUrl}/cake_api/productChannelLog?${joinParams({...filters, user_id: store.state.user.userInfo.id})}&export_type=${type}`)
    }
    const search = () => {
        filters.page = 1
        getList()
    }
    const onPageChange = (val) => {
        filters.page = val
        getList()
    }
    const onSizeChange = (val) => {
        filters.page_size = val
        getList()
    }
    onMounted(() => {
        getList()
    })

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SelectChannel, { onChannelChange: onChannelChange }),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.channel_name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.channel_name) = $event)),
        modelModifiers: { trim: true },
        placeholder: "渠道名称",
        size: "default",
        style: {"width":"200px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.title,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.title) = $event)),
        modelModifiers: { trim: true },
        placeholder: "商品名称",
        style: {"width":"170px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.start_date,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.start_date) = $event)),
        type: "date",
        "value-format": "YYYY-MM-DD",
        placeholder: "开始日期",
        style: {"width":"170px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _cache[8] || (_cache[8] = _createElementVNode("span", { class: "filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.end_date,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.end_date) = $event)),
        type: "date",
        "value-format": "YYYY-MM-DD",
        placeholder: "结束日期",
        style: {"width":"170px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (search()))
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (out(1)))
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [
          _createTextVNode("导出改价记录")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      stripe: "",
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, { type: "index" }),
        _createVNode(_component_el_table_column, {
          prop: "channel_name",
          label: "渠道名称"
        }),
        _createVNode(_component_el_table_column, {
          prop: "brand_name",
          label: "品牌"
        }),
        _createVNode(_component_el_table_column, {
          prop: "title",
          label: "电子券名称"
        }),
        _createVNode(_component_el_table_column, {
          prop: "mft_name",
          label: "厂家"
        }),
        _createVNode(_component_el_table_column, {
          prop: "type_name",
          label: "类型"
        }),
        _createVNode(_component_el_table_column, {
          prop: "channel_discount",
          label: "甜蜜兑折扣"
        }),
        _createVNode(_component_el_table_column, {
          prop: "price",
          label: "售价"
        }),
        _createVNode(_component_el_table_column, {
          prop: "mft_clearing_price",
          label: "厂家结算价"
        }),
        _createVNode(_component_el_table_column, {
          prop: "clearing_price",
          label: "渠道结算价"
        }),
        _createVNode(_component_el_table_column, {
          prop: "invoice_type_name",
          label: "发票类型"
        }),
        _createVNode(_component_el_table_column, {
          prop: "tax_Point",
          label: "税点信息"
        }),
        _createVNode(_component_el_table_column, {
          prop: "created_at",
          width: "170",
          label: "时间"
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      currentPage: filters.page,
      total: total.value,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total"])
  ]))
}
}

})